import React, { useMemo } from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

const TUNISIA_CENTER = [34.0, 9.6];
const DEFAULT_ZOOM = 6;

const ROLE_STYLES = {
  client: {
    color: '#3b82f6',
    fillColor: '#60a5fa',
    label: 'Client',
  },
  demenageur: {
    color: '#eab308',
    fillColor: '#facc15',
    label: 'Déménageur',
  },
};

function UsageZoneMap({ heatmap = [], loading }) {
  const points = useMemo(() => {
    if (!Array.isArray(heatmap)) return [];
    return heatmap.filter(
      (p) => p && Number.isFinite(p.lat) && Number.isFinite(p.lng)
    );
  }, [heatmap]);

  if (loading) {
    return (
      <div className="h-96 flex items-center justify-center bg-gray-900/50 rounded-lg border border-gray-700 text-gray-400">
        Chargement de la carte...
      </div>
    );
  }

  if (points.length === 0) {
    return (
      <div className="h-96 flex items-center justify-center bg-gray-900/50 rounded-lg border border-gray-700 text-gray-400 text-center px-6">
        Aucun point GPS utilisateur sur cette période (position enregistrée dans l&apos;app).
      </div>
    );
  }

  return (
    <div className="h-96 rounded-lg overflow-hidden border border-yellow-600/30 z-0">
      <MapContainer
        center={TUNISIA_CENTER}
        zoom={DEFAULT_ZOOM}
        className="h-full w-full"
        scrollWheelZoom
      >
        <TileLayer
          attribution="&copy; OpenStreetMap"
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {points.map((p, idx) => {
          const role = p.role === 'demenageur' ? 'demenageur' : 'client';
          const style = ROLE_STYLES[role] || ROLE_STYLES.client;
          return (
            <CircleMarker
              key={`${p.lat}-${p.lng}-${role}-${idx}`}
              center={[p.lat, p.lng]}
              radius={9}
              pathOptions={{
                color: style.color,
                fillColor: style.fillColor,
                fillOpacity: 0.5,
                weight: 1,
              }}
            >
              <Popup>
                <span className="text-sm">
                  {style.label} — ({p.lat.toFixed(4)}, {p.lng.toFixed(4)})
                </span>
              </Popup>
            </CircleMarker>
          );
        })}
      </MapContainer>
    </div>
  );
}

export default UsageZoneMap;
